module.exports = __webpack_public_path__ + "img/3.0de62f25.jpg";